<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (isPermissionMissing) {
  <div>
    <legend data-automation="fieldset-header-legend">
      {{ 'tkey;shared.model.microsoft_teams_calling.entra_attributes.header' | translate }}
    </legend>
    <div class="alert alert-warning d-flex justify-content-between">
      <span>
        <i [ngClass]="ziroIcons.WARNING_TRIANGLE"></i>
        <strong data-automation="entra-attribute-warning-banner-text">
          {{ 'tkey;shared.model.microsoft_teams_calling.entra_attributes.warning_banner.text' | translate }}
        </strong>
      </span>
    </div>
  </div>
}
@if (isAnyAttributeVisible) {
  <div>
    @if (!isLoading && !isPermissionMissing) {
      <div>
        <ziro-helpdesk-entra-attributes-form
          (ziroFormsUpdate$)="onChildFormUpdate($event)"
          [formConfig]="formConfig"
          [attributeFields]="attributeFields"
          [entity]="initialEntity"
        ></ziro-helpdesk-entra-attributes-form>
      </div>
    }
  </div>
}
